import React from 'react';
import { ModalContent } from './styles';
import { IModalSecondAccess } from './interfaces';
import ModalResponsive from 'components/ModalResponsive';
import * as Atoms from 'components/Atoms';

export const ModalSecondAccess: React.FC<IModalSecondAccess> = ({
  open,
  onClose,
  nameStore,
  isSharingLocation,
}) => {
  return (
    <ModalResponsive
      open={open}
      onClose={onClose}
      maxModalHeight={350}
      sizeModal="middle"
    >
      <ModalContent showModalSharingLocation={isSharingLocation}>
        {isSharingLocation ? (
          <>
            <h3>Você está longe do {nameStore}</h3>
            <p>
              Seu restaurante atual está longe da sua localização. Deseja
              continuar?
            </p>
            <Atoms.Button
              variant="menu"
              id="Teste"
              title="teste"
              onClick={onClose}
            >
              Continuar
            </Atoms.Button>
            <a href="/menu">Trocar Restaurante</a>
          </>
        ) : (
          <>
            <h3>Seu restaurante atual é {nameStore}.</h3>
            <Atoms.Button
              variant="menu"
              id="Teste"
              title="teste"
              onClick={onClose}
            >
              Continuar
            </Atoms.Button>
            <a href="/menu">Trocar Restaurante</a>
          </>
        )}
      </ModalContent>
    </ModalResponsive>
  );
};
